import { ListItem, Skeleton } from '@mui/material';
import React from 'react';

type Props = {
  numberOfItems: number;
};

export function SkeletonList({ numberOfItems }: Props) {
  return (
    <>
      {[...Array(numberOfItems)].map((_, index) => (
        <ListItem key={index} sx={{ pY: 1 }}>
          <Skeleton animation="wave" variant="text" width={300} height={20} />
        </ListItem>
      ))}
    </>
  );
}
